"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MstrStage = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
let MstrStage = class MstrStage {
    constructor(name, description, stageMeta, createdBy, updatedBy) {
        this.name = name;
        this.description = description;
        this.stageMeta = stageMeta;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
    }
};
exports.MstrStage = MstrStage;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], MstrStage.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: "varchar", length: 255 }),
    tslib_1.__metadata("design:type", String)
], MstrStage.prototype, "name", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], MstrStage.prototype, "description", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "stage_meta", type: "jsonb", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Record !== "undefined" && Record) === "function" ? _b : Object)
], MstrStage.prototype, "stageMeta", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "ref_role_key", type: "varchar", length: 255 }),
    tslib_1.__metadata("design:type", String)
], MstrStage.prototype, "refRoleKey", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], MstrStage.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], MstrStage.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], MstrStage.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at" }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], MstrStage.prototype, "updatedAt", void 0);
exports.MstrStage = MstrStage = tslib_1.__decorate([
    (0, typeorm_1.Entity)("mstr_stage"),
    tslib_1.__metadata("design:paramtypes", [String, String, typeof (_a = typeof Record !== "undefined" && Record) === "function" ? _a : Object, Number, Number])
], MstrStage);
